// Eski kök (`new Vue`) metotları `isNumber` / `filterOptions` buraya taşındı; şablonlar onlara `$root` ile
// değil `$isNumber` / `$filterOptions` global property'siyle ulaşır (Vue 3'te kök metotları yerine).
// Gövdeler main.js'ten alındı; `filterOptions` CompatVSelect'in varsayılan filtresiyle aynı eşleştiriciye bağlandı.
import { matchesQuery } from '../utils/highlight';

export const globalHelpers = {
    // v-select `filterBy`: Türkçe ı/İ ve aksan duyarsız, listedeki vurguyla aynı kural.
    filterOptions(option, label, search) {
      return matchesQuery(label, search);
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode >= 48 && charCode <= 57) || charCode == 44 || charCode == 46 || charCode == 37) {
        return true;
      } else {
        evt.preventDefault();
      }
    }
};

// Vue 2 (`Vue.use`) ve Vue 3 (`app.use`) ile aynı şekilde çalışır:
// Vue 2'de `Vue.prototype`, Vue 3'te `app.config.globalProperties` hedeflenir.
export default {
  install(app) {
    const target = app.config && app.config.globalProperties
      ? app.config.globalProperties
      : app.prototype;

    Object.keys(globalHelpers).forEach(name => {
      target['$' + name] = globalHelpers[name];
    });
  }
};
